import { createContext } from "react";

// Agent || Customer
export const PortalTypeContext = createContext(null);
